module.exports = __webpack_public_path__ + "static/media/flight-detail-banner.0e7ff1e2.jpg";